
import audio2 from '../../../../assets/sounds/adult/de/diktat/2.mp3';
import audio4 from '../../../../assets/sounds/adult/de/diktat/4.mp3';
import audio5 from '../../../../assets/sounds/adult/de/diktat/5.mp3';
import audio8 from '../../../../assets/sounds/adult/de/diktat/8.mp3';
import audio9 from '../../../../assets/sounds/adult/de/diktat/9.mp3';
import audio12 from '../../../../assets/sounds/adult/de/diktat/12.mp3';
import audio13 from '../../../../assets/sounds/adult/de/diktat/13.mp3';
import audio16 from '../../../../assets/sounds/adult/de/diktat/16.mp3';
import audio17 from '../../../../assets/sounds/adult/de/diktat/17.mp3';
import audio18 from '../../../../assets/sounds/adult/de/diktat/18.mp3';
import audio19 from '../../../../assets/sounds/adult/de/diktat/19.mp3';
import audio20 from '../../../../assets/sounds/adult/de/diktat/20.mp3';
import audio22 from '../../../../assets/sounds/adult/de/diktat/22.mp3';
import audio24 from '../../../../assets/sounds/adult/de/diktat/24.mp3';
import audio25 from '../../../../assets/sounds/adult/de/diktat/25.mp3';
import audio26 from '../../../../assets/sounds/adult/de/diktat/26.mp3';
import audio27 from '../../../../assets/sounds/adult/de/diktat/27.mp3';
import audio28 from '../../../../assets/sounds/adult/de/diktat/28.mp3';
import audio29 from '../../../../assets/sounds/adult/de/diktat/29.mp3';
import audio30 from '../../../../assets/sounds/adult/de/diktat/30.mp3';
import audio31 from '../../../../assets/sounds/adult/de/diktat/31.mp3';
import audio33 from '../../../../assets/sounds/adult/de/diktat/33.mp3';
import audio34 from '../../../../assets/sounds/adult/de/diktat/34.mp3';
import audio35 from '../../../../assets/sounds/adult/de/diktat/35.mp3';
import audio36 from '../../../../assets/sounds/adult/de/diktat/36.mp3';
import audio38 from '../../../../assets/sounds/adult/de/diktat/38.mp3';
import audio40 from '../../../../assets/sounds/adult/de/diktat/40.mp3';
import audio41 from '../../../../assets/sounds/adult/de/diktat/41.mp3';
import audio46 from '../../../../assets/sounds/adult/de/diktat/46.mp3';
import audio49 from '../../../../assets/sounds/adult/de/diktat/49.mp3';
import audio51 from '../../../../assets/sounds/adult/de/diktat/51.mp3';

// Four new recordings
import audioNew1 from '../../../../assets/sounds/adult/de/diktat/SCR-A-new1.mp3';
import audioNew2 from '../../../../assets/sounds/adult/de/diktat/SCR-A-new2.mp3';
import audioNew3 from '../../../../assets/sounds/adult/de/diktat/SCR-A-new3.mp3';
import audioNew4 from '../../../../assets/sounds/adult/de/diktat/SCR-A-new4.mp3';

// New item order (1-35)
const audioFiles = {
    1: audioNew1,
    2: audio2,
    3: audio4,
    4: audio5,
    5: audio8,
    6: audio9,
    7: audioNew2,
    8: audio12,
    9: audio13,
    10: audio16,
    11: audio17,
    12: audio18,
    13: audio19,
    14: audio20,
    15: audioNew3,
    16: audio22,
    17: audio24,
    18: audio25,
    19: audio26,
    20: audio27,
    21: audio28,
    22: audio29,
    23: audio30,
    24: audio31,
    25: audio33,
    26: audio34,
    27: audio35,
    28: audio36,
    29: audio38,
    30: audio40,
    31: audio41,
    32: audioNew4,
    33: audio46,
    34: audio49,
    35: audio51,
};

export default audioFiles;
